module.exports = __webpack_public_path__ + "static/media/door.1d71944e.png";